var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010202;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#88898C;}\n\t.st3{fill:#EB5F27;}\n\t.st4{clip-path:url(#SVGID_4_);}\n\t.st5{clip-path:url(#SVGID_6_);}\n\t.st6{clip-path:url(#SVGID_8_);}\n\t.st7{clip-path:url(#SVGID_10_);}\n\t.st8{fill:#EC672D;}\n\t.st9{fill:#F1F1F1;}\n\t.st10{clip-path:url(#SVGID_12_);}\n\t.st11{clip-path:url(#SVGID_14_);}\n\t.st12{fill:none;stroke:#6E6F72;stroke-width:0.8;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#88898C;stroke-width:0.8;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#494949;stroke-width:0.8;stroke-miterlimit:10;}\n\t.st15{fill:#6E6F72;}\n\t.st16{fill:none;stroke:#6E6F72;stroke-miterlimit:10;}\n\t.st17{fill:#717171;}\n\t.st18{fill:none;stroke:#717171;stroke-width:0.5706;stroke-miterlimit:3.8636;}\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:#E85410;}\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:#717171;}\n\t.st21{fill:#E85410;}\n\t.st22{fill:#FFFFFF;}\n\t.st23{clip-path:url(#SVGID_16_);}\n\t.st24{clip-path:url(#SVGID_18_);}\n\t.st25{clip-path:url(#SVGID_20_);}\n\t.st26{clip-path:url(#SVGID_22_);}\n\t.st27{clip-path:url(#SVGID_24_);}\n\t.st28{fill:#B5B5B7;}\n\t.st29{fill:#EBEBEB;}\n\t.st30{fill:#5B5B5B;}\n\t.st31{fill:#E15217;}\n\t.st32{fill:#0856A3;}\n\t.st33{fill:#BFBEBF;}\n\t.st34{fill:#485055;}\n\t.st35{fill:#32393F;}\n\t.st36{fill:#586065;}\n\t.st37{fill:#F29068;}\n\t.st38{fill:#F18A5F;}\n\t.st39{fill:#AA7A64;}\n\t.st40{fill:#B88C7B;}\n\t.st41{fill:#DA6837;}\n\t.st42{fill:#E46531;}\n\t.st43{fill:#F1BA87;}\n\t.st44{fill:#F1D0A5;}\n\t.st45{fill:#D37C56;}\n\t.st46{fill:#CE6B3F;}\n\t.st47{fill:#ED6A36;}\n\t.st48{fill:#B74B25;}\n\t.st49{fill:#E9511E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "fam"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("g", null))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "masivo"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "salud"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "viajes"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "coporativos"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "headphone"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "web"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "llamanos"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "segurnet"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "estrellas"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "fb"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "ig"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M21.9,0H8.1C3.6,0,0,3.6,0,8.1v13.8C0,26.4,3.6,30,8.1,30h13.8c4.5,0,8.1-3.6,8.1-8.1V8.1 C30,3.6,26.4,0,21.9,0L21.9,0z M28.2,21.9c0,3.5-2.9,6.4-6.4,6.4H8.1c-3.5,0-6.4-2.9-6.4-6.4V8.1c0-3.5,2.9-6.4,6.4-6.4h13.8 c3.5,0,6.4,2.9,6.4,6.4V21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M15,6.8c-4.5,0-8.2,3.7-8.2,8.2c0,4.5,3.7,8.2,8.2,8.2s8.2-3.7,8.2-8.2C23.2,10.5,19.5,6.8,15,6.8z M15,21.4 c-3.6,0-6.4-2.9-6.4-6.4c0-3.6,2.9-6.4,6.4-6.4c3.6,0,6.4,2.9,6.4,6.4C21.4,18.6,18.6,21.4,15,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M23.4,3.9C22.1,3.9,21,5,21,6.3c0,1.3,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4S24.7,3.9,23.4,3.9z M23.4,7 c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7C24.1,6.7,23.8,7,23.4,7z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "valores"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "vision"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "personas"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "direccion"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "tele"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "correo"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "horario"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "wassap"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "seguro"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.c652ae9df065761d32a6be7aadbd99cb.svg";
export { ForwardRef as ReactComponent };